import { mutator } from 'satcheljs';
import getStore from '../store/store';
import updatePublishingSettings from '../actions/updatePublishingSettings';

/**
 * Updates the personal booking page publishing settings in the store.
 */
export default mutator(updatePublishingSettings, actionMessage => {
    let store = getStore();
    store.publishingSettings = actionMessage.pbpPublishingSettings;
});
